import React from 'react';
import { SearchIcon, MousePointerClickIcon, WorkflowIcon } from 'lucide-react';
import { services } from '../data/homepage';
const icons = {
  found: SearchIcon,
  convert: MousePointerClickIcon,
  busywork: WorkflowIcon
} as const;
export function ServicesSection() {
  return <section id="services" aria-labelledby="services-title" className="bg-paper" data-id="element-126" data-mp="2l969k0vkzm6e">
      <div className="mx-auto max-w-[1280px] px-5 py-12 md:px-8 md:py-16 lg:py-20" data-id="element-127" data-mp="2lb9b9i63j3qy">
        <h2 id="services-title" className="max-w-[640px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-128" data-mp="26ifhqstzon3a">
          Attract customers. Simplify the work.
        </h2>

        <div className="mt-8 grid border-t border-rule md:mt-10 md:grid-cols-3 md:divide-x md:divide-rule" data-id="element-129" data-mp="1xi0uvp1dmzxo">
          {services.map(service => {
          const Icon = icons[service.id as keyof typeof icons];
          return <article key={service.id} className="flex flex-col border-b border-rule py-7 last:border-b-0 md:border-b-0 md:px-8 md:pb-2 md:pt-9 md:first:pl-0 md:last:pr-0" data-id="element-130" data-mp="1sl0ote4j1x6k">
                <Icon className="h-7 w-7 text-brand-greenDeep" strokeWidth={1.75} aria-hidden data-id="element-131" data-mp="2knexnfp3z8a6" />
                <h3 className="mt-5 text-[22px] font-bold leading-tight text-ink" data-id="element-132" data-mp="2ymodge9ek0dm">{service.title}</h3>
                <p className="mt-3 max-w-[380px] text-[16px] leading-[1.6] text-ink/80" data-id="element-133" data-mp="2unp66n077rj0">{service.body}</p>
                <p className="mt-auto pt-6 text-[14px] font-semibold leading-snug text-muted" data-id="element-134" data-mp="26xbcks1ytkmb">{service.line}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}